import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { TabelaBase } from '../../../../../components/formControls/TabelaBase';
import { LicitacaoList } from '../types/Licitacao';

interface Props {
  licitacoes: LicitacaoList[];
  handleExcluirtClick: (rowData: LicitacaoList) => void;
  // Se quiser, também um handleEditClick ou baseEditUrl para link
  baseEditUrl?: string;
}

export const LicitacaoDataTable = ({ licitacoes, handleExcluirtClick, baseEditUrl }: Props) => {
  // Renderizadores podem ficar dentro do componente
  const renderData = (rowData: LicitacaoList) => {
    const dataCriacao = rowData.dataHoraCriacao ? format(rowData.dataHoraCriacao, 'dd/MM/yyyy') : 'Data não disponível';
    return (
      <Typography color="secondary" variant="body2">
        {dataCriacao}
      </Typography>
    );
  };

  const renderUsuario = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.usuario?.nome || 'Usuário não disponível'}
    </Typography>
  );

  const renderProcesso = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.processo || ''}
    </Typography>
  );
  const renderPregao = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.pregao || ''}
    </Typography>
  );
  const renderObjeto = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.objeto || ''}
    </Typography>
  );
  const renderSituacao = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.situacao.nome || ''}
    </Typography>
  );
  const renderModalidade = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.modalidade.nome || ''}
    </Typography>
  );
  const renderFiscal = (rowData: LicitacaoList) => (
    <Typography color="secondary" variant="body2">
      {rowData.fiscal || ''}
    </Typography>
  );

  const renderAction = (rowData: LicitacaoList) => (
    <Box display="flex" gap={1}>
      <Tooltip title="Editar">
        {baseEditUrl ? (
          <Link to={`${baseEditUrl}${rowData.id}`}>
            <IconButton color="secondary" aria-label="edit">
              <EditIcon />
            </IconButton>
          </Link>
        ) : (
          <IconButton color="secondary" aria-label="edit">
            {/* Se quiser, pode passar um handleEditClick aqui */}
            <EditIcon />
          </IconButton>
        )}
      </Tooltip>

      <Tooltip title="Excluir">
        <IconButton color="secondary" aria-label="delete" onClick={() => handleExcluirtClick(rowData)}>
          <GridDeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
  /*
  const columns = [
    { header: 'Data', body: renderData, sortable: true, filter: false, filterPlaceholder: 'Filtrar por data', style: { width: 'auto' }, frozen: false },
    { header: 'Processo', body: renderProcesso, sortable: true, filter: false, filterPlaceholder: 'Filtrar por processo', style: { width: '15%' } },
    { header: 'Pregão', body: renderPregao, sortable: true, filter: false, filterPlaceholder: 'Filtrar por pregão', style: { width: '40%' } },
    { header: 'Objeto', body: renderObjeto, sortable: true, filter: false, filterPlaceholder: 'Filtrar por objeto', style: { width: '40%' } },
    { header: 'Situação', body: renderSituacao, sortable: true, filter: false, filterPlaceholder: 'Filtrar por situação', style: { width: '40%' } },
    { header: 'Modalidade', body: renderModalidade, sortable: true, filter: false, filterPlaceholder: 'Filtrar por modalidade', style: { width: '40%' } },
    { header: 'Fiscal', body: renderFiscal, sortable: true, filter: false, filterPlaceholder: 'Filtrar por fiscal', style: { width: '40%' } },
    //{ header: 'Usuário', body: renderUsuario, sortable: true, filter: false, filterPlaceholder: 'Filtrar por usuário', style: { width: 'auto' } },
    { header: 'Ações', body: renderAction, style: { width: 'auto' } }
  ];*/

  const columns = [
    { header: 'Data', body: renderData, sortable: false, filter: false },
    { header: 'Processo', body: renderProcesso, sortable: true, filter: false },
    { header: 'Pregão', body: renderPregao, sortable: true, filter: false },
    {
      header: 'Objeto',
      body: renderObjeto,
      sortable: true,
      filter: false,
      filterPlaceholder: 'Filtrar por objeto',
      style: { width: '400px', minWidth: '200px', maxWidth: '600px' } // largura fixa em px
    },
    { header: 'Situação', body: renderSituacao, sortable: true, filter: false },
    { header: 'Modalidade', body: renderModalidade, sortable: true, filter: false },
    { header: 'Fiscal', body: renderFiscal, sortable: true, filter: false },
    { header: 'Ações', body: renderAction }
  ];
  

  const headerGerados = (
    <Typography variant="body2" color="textSecondary">
      Registro(s) encontrado(s): {licitacoes.length}
    </Typography>
  );

  return (
    <>
      <TabelaBase
        value={licitacoes}
        columns={columns}
        dataKey="id"
        header={headerGerados}
        rows={25}
        paginator
        exportCSV={false}
        scrollable
        scrollHeight="500px"
        frozenWidth="150px"
        themeClassName="meu-tema-customizado"
      />
    </>
  );
};
